import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  city: "",
  region: "",
  country: "",
  latitude: null,
  longitude: null,
  timezone: null,
  loading: false,
  error: null,
  isInitialized: false,
  lastFetched: null,
  config: {
    enableGeolocation: true,
    enableIPLookup: true,
    cacheTimeout: 24 * 60 * 60 * 1000, // 24 hours in milliseconds
    retryAttempts: 3,
    retryDelay: 1000, // 1 second
  },
};

export const geolocationSlice = createSlice({
  name: "geolocation",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setLocation: (state, action) => {
      const { city, region, country, latitude, longitude, timezone } = action.payload;
      state.city = city;
      state.region = region;
      state.country = country;
      state.latitude = latitude;
      state.longitude = longitude;
      state.timezone = timezone;
      state.loading = false;
      state.error = null;
      state.isInitialized = true;
      state.lastFetched = Date.now();
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    resetLocation: (state) => {
      return { ...initialState, config: state.config };
    },
    updateConfig: (state, action) => {
      state.config = { ...state.config, ...action.payload };
    },
    setInitialized: (state, action) => {
      state.isInitialized = action.payload;
    },
  },
});

export const {
  setLoading,
  setLocation,
  setError,
  resetLocation,
  updateConfig,
  setInitialized,
} = geolocationSlice.actions;

export default geolocationSlice.reducer;

